












































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { fetchNDV } from '../../fetchNDV';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';
import {
  ParamsApi,
  DataApi,
  FilterApi,
  FunctionParams,
  ContextMsg,
  ParamsAttention,
} from '../../models/NDVBase.model';

import { ProductApi } from '../../models/NDVModalTabs.model';
import { LoadingService } from '@/services/loadingService';
import Confirmation from '@/components/Confirmation.vue';

@Component({ components: { GridComponent: AgGridVue, Confirmation } })
export default class TabProductsReservation extends Vue {
  @Prop({ required: true, default: {} }) data!: ProductApi[];
  @Prop({ required: true, default: '' }) ndv!: string;
  @Prop({ required: true, default: '' }) ndvnumero!: string;

  readonly loadingService = new LoadingService();
  columnApi: any = null;
  columnApiResp: any = null;
  gridOptions: GridOptions = null;
  gridOptionsResp: GridOptions = null;
  gridEvent: any = null;
  gridEventResp: any = null;
  gridApi: GridApi = null;
  gridApiResp: GridApi = null;
  columnDefs: ColDef[] = [];
  columnDefsResp: ColDef[] = [];
  listData: any = [];
  lista_series: any = [];
  uniqueItems: unknown = [];
  ver_resumen: boolean = false;
  $snotify: any;
  series: any = [];
  selectedItem: string = '';
  selectedSerie: string = '';
  nuevaLista: Array<{
    ProductoSeleccionado: null | string;
    NombreProducto: null | string;
    NombreSerie: null | string;
    EPC: null | string;
  }> = [];
  lista_respuesta: Array<{
    NombreProducto: null | string;
    NombreSerie: null | string;
    NombreEPC: null | string;
    InformacionProceso: null | string;
  }> = [];
  dialogPopUp: boolean = false;
  contextPopUp: ContextMsg = {};
  confirmations: number = 0;

  constructor() {
    super();
    this.getSeries();
    this.getProductosRestantes();
    this.columnDefs = this.colsGrid();
    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    //console.log('event.api', event.api)
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.nuevaLista);
    this.gridApi.setDomLayout('autoHeight');
  }
  handleRespGridReady(event: GridReadyEvent): void {
    this.gridApiResp = event.api;
    //console.log('event.columnApi', event.columnApi)
    this.columnApiResp = event.columnApi;
    this.gridEventResp = event;
    this.gridApiResp.setRowData(this.lista_respuesta);
    this.gridApiResp.setDomLayout('autoHeight');
  }
  mounted() {}
  private createGrid() {
    this.columnDefsResp = this.colsGridResp();
    this.gridOptionsResp = {
      columnDefs: this.columnDefsResp,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleRespGridReady,
    };
  }
  async getSeries() {
    await fetchNDV({
      endpoint: 'get_series',
      body: {},
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          return this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        console.log('response.data', response.data['LISTA']);
        // this.series = response.data['LISTA'];
        this.series = response.data['LISTA'].map(
          (item: { key: any; value: any }) => ({
            text: item.key,
            value: item.value,
          })
        );
        return response.data;
      })
      .catch((error: Error) => {
        //console.error(error.message);
        this.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => this.loadingService.hideLoading());
  }
  async getProductosRestantes() {
    await fetchNDV({
      endpoint: 'get_productos_restantes',
      body: {
        ndvnumero: this.ndvnumero,
      },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          return this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        const lista = response.data['LISTA'];
        let contador = 1;
        // this.lista_series = lista.flatMap(
        //   (item: {
        //     restantes: string;
        //     ndvnumero: any;
        //     ndvproducto: string;
        //   }) => {
        //     return Array.from({ length: parseInt(item.restantes) }, () => ({
        //       ndvnumero: item.ndvnumero,
        //       nro_producto: (contador++).toString() + '-' + item.ndvproducto,
        //     }));
        //   }
        // );
        this.lista_series = lista.map(
          (item: { ndvproducto: string; ndvepc: string }) => ({
            nro_producto: item.ndvproducto + ' | ' + item.ndvepc,
          })
        );
        //console.log('this.lista_series ', this.lista_series)
        return;
      })
      .catch((error: Error) => {
        //console.error(error.message);
        this.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => this.loadingService.hideLoading());
  }
  agregar() {
    if (!this.selectedItem || !this.selectedSerie)
      return this.$snotify.error('Debe seleccionar un producto y una serie', {
        timeout: 3000,
      });
    console.log('this.selectedItem ', this.selectedItem);
    let productoSeleccionado = this.selectedItem.split('|')[0].trim();
    let nombreInterno = this.selectedSerie.match(/\(([^)]+)\)/)[1];
    let epc = this.selectedItem.split('|')[1];
    let serie = this.selectedSerie.split('-')[0];
    this.nuevaLista.push({
      ProductoSeleccionado: productoSeleccionado,
      NombreProducto: nombreInterno,
      NombreSerie: serie,
      EPC: epc,
    });
    this.lista_series = this.lista_series.filter(
      (item: { nro_producto: null }) => item.nro_producto !== this.selectedItem
    );
    this.series = this.series.filter(
      (item: { serie: null }) => item.serie !== this.selectedSerie
    );
    this.selectedSerie = '';
    this.selectedItem = '';
    this.gridApi.setRowData(this.nuevaLista);
  }
  async guardar(confirmation: boolean): Promise<void> {
    const self = this;
    if (!confirmation) return;
    // //console.log('this.nuevaLista ', this.nuevaLista)
    this.loadingService.showLoading();
    const userId = this.getUserId();
    const id_cliente = this.getClientId();
    const user = localStorage.getItem('user');
    const rut = JSON.parse(user.replace(/'/g, '"')).rutClienteDefecto;
    // //console.log('rut ', rut)
    const listaLimpia = this.nuevaLista.map(item => {
      const { ProductoSeleccionado, EPC, ...rest } = item;
      return rest;
    });
    await fetchNDV({
      endpoint: 'agrega_series',
      body: {
        userId,
        rut,
        id_cliente,
        ndvnumero: this.ndv,
        lista_series: listaLimpia,
        eliminar_anterios: true,
      },
    })
      .then(response => {
        //console.log('response ', response)
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          return self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        self.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
        this.lista_respuesta = LISTA;
        this.createGrid();
        //console.log('LISTA', LISTA)
        // return this.$emit('cerrar');
      })
      .catch((error: Error) => {
        //console.error(error.message);
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => {
        this.dialogPopUp = false;
        self.loadingService.hideLoading();
        this.gridApi.setRowData(this.nuevaLista);
      });
    this.ver_resumen = true;
    //console.log(this.ver_resumen)
  }
  handleGenerateAttention(params: { data: DataApi }): void {
    if (this.nuevaLista && this.nuevaLista.length < 1) {
      this.dialogPopUp = false;
      return this.$snotify.error(
        'No has asignado ninguna serie a la nota de venta',
        { timeout: 3000 }
      );
    }
    this.dialogPopUp = true;
    this.contextPopUp = {
      title: 'Generar Atención',
      msg: `¿Está seguro que desea asignar los números de serie a la nota de venta ${this.ndv}?`,
      attention: params.data,
      btnConfirmation: 'Confirmar',
    };
  }

  beforeDestroy() {
    this.handleCancel();
  }
  handleCancel() {
    this.$emit('cerrar');
  }
  private colsGrid(): ColDef[] {
    const coldef: ColDef[] = [
      {
        headerName: 'Producto Seleccionado',
        field: 'ProductoSeleccionado',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'Nombre Interno',
        field: 'NombreProducto',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'EPC',
        field: 'EPC',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'Número de serie',
        field: 'NombreSerie',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
    ];
    return coldef;
  }
  private colsGridResp(): ColDef[] {
    const coldef: ColDef[] = [
      {
        headerName: 'Producto',
        field: 'NombreProducto',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'Número de serie',
        field: 'NombreSerie',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'Nombre EPC',
        field: 'NombreEPC',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'Información Proceso',
        field: 'InformacionProceso',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
    ];
    return coldef;
  }
  private getUserId = (): number => {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return parseInt(id);
  };
  private getClientId = (): number => {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).clienteDefecto;
    return parseInt(id);
  };
}
